import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLineChart4"><Path d="M21.4967 16.5V19.5M15.1641 12.5L15.1641 19.5M8.83203 8.5V19.5M2.5 4.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLineChart4;
